import { ReactElement, useMemo, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation as ErrorIcon } from '@fortawesome/free-solid-svg-icons';
import { red } from '@mui/material/colors';

import { formatterDate } from '~utils/formatter';
import { comparateDateToNow } from '~utils/commons';

import { ExpirationDateInfoProps } from './types';
import DescriptionWithIconBox from '../DescriptionWithIconBox';
import { DescriptionWithIconBoxText } from '../DescriptionWithIconBox/styles';

const DEFAULT_TOOLTIP_MESSAGE = 'Pedido vencido';

const ExpirationDateInfo = ({
  expirationDate,
  fontSize = 14,
  fontWeight,
  tooltipMessage = DEFAULT_TOOLTIP_MESSAGE,
  comparationType = 'before',
}: ExpirationDateInfoProps): ReactElement => {
  const hasExpired = useMemo(
    () =>
      comparateDateToNow({
        date: expirationDate,
        comparationType,
      }),
    [expirationDate, comparationType],
  );

  const parseExpirationDate = useMemo(
    () =>
      expirationDate
        ? formatterDate(expirationDate, { format: 'DD/MM/YYYY' })
        : 'Sin vencimiento',
    [expirationDate],
  );

  if (!hasExpired)
    return (
      <DescriptionWithIconBoxText variant="inherit" fontWeight={fontWeight}>
        {parseExpirationDate}
      </DescriptionWithIconBoxText>
    );

  return (
    <DescriptionWithIconBox
      icon={<FontAwesomeIcon icon={ErrorIcon} />}
      iconTooltip={tooltipMessage}
      iconPosition="left"
      iconColor={red['500']}
      description={parseExpirationDate}
      size={fontSize}
      fontWeight={fontWeight}
    />
  );
};

export default memo(ExpirationDateInfo);
